import styled from 'styled-components';

export function Switch({ title, className, value, setValue }: { title: string, className?: string, value: boolean, setValue: () => void }) {
   return (
      <Main className={`switch ${className}`}>
         <div onClick={ setValue }>
            <div className={`toggle ${value ? 'active' : ''}`}>
               <span></span>
            </div>
            <h4>{ title }</h4>
         </div>
      </Main>
   );
}

// ---
const Main = styled.div`
   display: flex;
   justify-content: center;

   &.autopilot {
      margin-top: 20px;
      margin-bottom: 10px;

      &+p {
         width: 300px;
         margin: auto;
         text-align: center;
         font-size: 14px;
         color: #ff0000;
         opacity: 0.75;
         line-height: 1.3;
      }
   }
   > div {
      display: flex;
      align-items: center;
      cursor: pointer;
   }
   .toggle {
      position: relative;
      background-color: rgb(240, 240, 240);
      width: 40px;
      height: 20px;
      border-radius: 25px;
      margin-right: 7.5px;
      transition: all .2s ease-in-out;

      span {
         position: absolute;
         top: 2px;
         left: 3.5px;
         width: 15px;
         height: 15px;
         background-color: rgb(255, 255, 255);
         box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
         border-radius: 50%;
         transition: all .2s linear;
      }
      &.active {
         background-color: #3E82F8;

         span {
            left: calc(100% - 15px - 3.5px);
         }
      }
   }
   h4 {
      font-weight: 400;
      font-size: 15px;
   }
`;